export default __webpack_public_path__ + "eba1386af19fe0ffa13d3c80b8123bd0.png";